var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var _cartAcceleratedWasHidden, _cartAddPending, _cartReviewRequired, _cartAddController, _resetTimeouts, _preloadImage, _AddToCartComponent_instances, animateFlyToCart_fn, _abortController, _timeout, _variantChangeInProgress, _variantChangeGeneration, _addToCartQueue, _ProductFormComponent_instances, getVariantIdInput_fn, refreshCart_fn, updateCartQuantity_fn, _onCartUpdate, getIntendedVariantId_fn, getQuantity_fn, processAddToCart_fn, processBatchAddToCart_fn, updateQuantityLabel_fn, setLiveRegionText_fn, clearLiveRegionText_fn, morphOrUpdateElement_fn, _onProductSelect;
import { Component } from "@theme/component";
import { trackCartRequest, applyCurrentCartItems } from "@theme/section-renderer";
import { fetchConfig, fetchCartJson, setCartCheckout, preloadImage, onAnimationEnd, yieldToMainThread } from "@theme/utilities";
import { cartPerformance } from "@theme/performance";
import { morph } from "@theme/morph";
import { CartLinesUpdateEvent, CartErrorEvent, ProductSelectEvent, StandardEvents } from "@shopify/events";
const ERROR_MESSAGE_DISPLAY_DURATION = 1e4;
const ERROR_BUTTON_REENABLE_DELAY = 1e3;
const SUCCESS_MESSAGE_DISPLAY_DURATION = 5e3;
class AddToCartComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _AddToCartComponent_instances);
    __publicField(this, "requiredRefs", ["addToCartButton"]);
    __privateAdd(
      this,
      _resetTimeouts,
      /** @type {number[]} */
      []
    );
    __privateAdd(this, _preloadImage, () => {
      const image = this.dataset.productVariantMedia;
      if (!image) return;
      preloadImage(image);
    });
    __publicField(this, "animateAddToCart", async function() {
      const { addToCartButton } = this.refs;
      if (!__privateGet(this, _resetTimeouts)) {
        __privateSet(this, _resetTimeouts, []);
      }
      __privateGet(this, _resetTimeouts).forEach(
        /** @param {number} timeoutId */
        (timeoutId2) => clearTimeout(timeoutId2)
      );
      __privateSet(this, _resetTimeouts, []);
      if (addToCartButton.dataset.added !== "true") {
        addToCartButton.dataset.added = "true";
      }
      await yieldToMainThread();
      await onAnimationEnd(addToCartButton);
      const timeoutId = setTimeout(() => {
        addToCartButton.removeAttribute("data-added");
        const index = __privateGet(this, _resetTimeouts).indexOf(timeoutId);
        if (index > -1) {
          __privateGet(this, _resetTimeouts).splice(index, 1);
        }
      }, 800);
      __privateGet(this, _resetTimeouts).push(timeoutId);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("pointerenter", __privateGet(this, _preloadImage));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (__privateGet(this, _resetTimeouts)) {
      __privateGet(this, _resetTimeouts).forEach(
        /** @param {number} timeoutId */
        (timeoutId) => clearTimeout(timeoutId)
      );
    }
    this.removeEventListener("pointerenter", __privateGet(this, _preloadImage));
  }
  /**
   * Disables the add to cart button.
   */
  disable() {
    this.refs.addToCartButton.disabled = true;
  }
  /**
   * Enables the add to cart button.
   */
  enable() {
    this.refs.addToCartButton.disabled = false;
  }
  /**
   * Handles the click event for the add to cart button.
   * @param {MouseEvent & {target: HTMLElement}} event - The click event.
   */
  handleClick(event) {
    const form = this.closest("form");
    if (!(form == null ? void 0 : form.checkValidity())) return;
    const productForm = (
      /** @type {ProductFormComponent | null} */
      this.closest("product-form-component")
    );
    const quantitySelector = productForm == null ? void 0 : productForm.refs.quantitySelector;
    if (quantitySelector == null ? void 0 : quantitySelector.canAddToCart) {
      const validation = quantitySelector.canAddToCart();
      if (!validation.canAdd) {
        return;
      }
    }
  }
  confirmAdded() {
    if (this.refs.addToCartButton.dataset.puppet !== "true") {
      const animationEnabled = this.dataset.addToCartAnimation === "true";
      if (animationEnabled && !this.closest(".quick-add-modal")) {
        __privateMethod(this, _AddToCartComponent_instances, animateFlyToCart_fn).call(this);
      }
      return this.animateAddToCart();
    }
  }
}
_resetTimeouts = /* @__PURE__ */ new WeakMap();
_preloadImage = /* @__PURE__ */ new WeakMap();
_AddToCartComponent_instances = /* @__PURE__ */ new WeakSet();
animateFlyToCart_fn = function() {
  const { addToCartButton } = this.refs;
  const cartIcon = document.querySelector(".header-actions__cart-icon");
  const image = this.dataset.productVariantMedia;
  if (!cartIcon || !addToCartButton || !image) return;
  const flyToCartElement = (
    /** @type {FlyToCart} */
    document.createElement("fly-to-cart")
  );
  let flyToCartClass = addToCartButton.classList.contains("quick-add__button") ? "fly-to-cart--quick" : "fly-to-cart--main";
  flyToCartElement.classList.add(flyToCartClass);
  flyToCartElement.style.setProperty("background-image", "url(".concat(image, ")"));
  flyToCartElement.style.setProperty("--start-opacity", "0");
  flyToCartElement.source = addToCartButton;
  flyToCartElement.destination = cartIcon;
  document.body.appendChild(flyToCartElement);
};
if (!customElements.get("add-to-cart-component")) {
  customElements.define("add-to-cart-component", AddToCartComponent);
}
class ProductFormComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductFormComponent_instances);
    __publicField(this, "requiredRefs", ["variantId", "liveRegion"]);
    __privateAdd(this, _abortController, new AbortController());
    __privateAdd(this, _timeout);
    __privateAdd(this, _cartAcceleratedWasHidden, true);
    __privateAdd(this, _cartAddPending, false);
    __privateAdd(this, _cartReviewRequired, false);
    __privateAdd(this, _cartAddController, null);
    __privateAdd(this, _variantChangeInProgress, false);
    __privateAdd(this, _variantChangeGeneration, 0);
    __privateAdd(this, _addToCartQueue, []);
    __privateAdd(this, _onCartUpdate, async (event) => {
      const ticket = trackCartRequest(event.promise);
      const lifecycle = __privateGet(this, _abortController);
      if (!event.promise || !__privateMethod(this, _ProductFormComponent_instances, getVariantIdInput_fn).call(this)) return;
      try {
        const { detail } = await event.promise;
        if (lifecycle.signal.aborted || detail && detail.sourceId === this.id && detail.quantityManagedBySource) return;
        await this.refreshProductCart(detail && detail.items, detail && detail.source === "pb-card-add" ? null : ticket);
      } catch (error) {
        if (error && error.name !== "AbortError" && !lifecycle.signal.aborted) console.warn("[product-form] Cart refresh failed:", error);
      }
    });
    __privateAdd(this, _onProductSelect, async (event) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const sourceCard = (
        /** @type {Element | null} */
        (_a = event.target) == null ? void 0 : _a.closest("product-card")
      );
      if (sourceCard && !sourceCard.contains(this)) return;
      const generation = ++__privateWrapper(this, _variantChangeGeneration)._;
      __privateSet(this, _variantChangeInProgress, true);
      const status = this.refs.variantStatus;
      if (status) {
        status.textContent = this.dataset.variantPending || "";
        status.hidden = false;
      }
      const previousButtons = Array.from(this.querySelectorAll("add-to-cart-component")).map((container) => ({ container, disabled: container.refs.addToCartButton.disabled }));
      const accelerated = this.refs.acceleratedCheckoutButtonContainer;
      const acceleratedWasHidden = accelerated && accelerated.hasAttribute("hidden");
      for (const entry of previousButtons) entry.container.disable();
      if (this.refs.acceleratedCheckoutButtonContainer) this.refs.acceleratedCheckoutButtonContainer.setAttribute("hidden", "true");
      try {
        const { detail } = await event.promise;
        if (generation !== __privateGet(this, _variantChangeGeneration) || __privateGet(this, _abortController).signal.aborted) return;
        if (!(detail == null ? void 0 : detail.html)) throw new Error("Variant response missing");
        const { html, newProduct, productId, resource } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (productId && productId !== this.dataset.productId) {
          if (status) status.hidden = true;
          for (const entry of previousButtons) {
            if (entry.disabled) entry.container.disable();
            else entry.container.enable();
          }
          if (accelerated && !acceleratedWasHidden) accelerated.removeAttribute("hidden");
          return;
        }
        if (status) status.hidden = true;
        const { variantId } = this.refs;
        variantId.value = (_b = resource == null ? void 0 : resource.id) != null ? _b : "";
        variantId.disabled = !resource || resource.available === false;
        const { addToCartButtonContainer: currentAddToCartButtonContainer, acceleratedCheckoutButtonContainer } = this.refs;
        const currentAddToCartButton = currentAddToCartButtonContainer == null ? void 0 : currentAddToCartButtonContainer.refs.addToCartButton;
        if (!currentAddToCartButtonContainer || !currentAddToCartButton && !acceleratedCheckoutButtonContainer) return;
        if (resource == null || resource.available == false) {
          currentAddToCartButtonContainer.disable();
        } else {
          currentAddToCartButtonContainer.enable();
        }
        const newAddToCartButton = html.querySelector('product-form-component [ref="addToCartButton"]');
        if (newAddToCartButton && currentAddToCartButton) {
          morph(currentAddToCartButton, newAddToCartButton);
        }
        if ((__privateGet(this, _cartAddPending) || __privateGet(this, _cartReviewRequired)) && acceleratedCheckoutButtonContainer) {
          __privateSet(this, _cartAcceleratedWasHidden, resource == null || resource.available == false);
        }
        if (acceleratedCheckoutButtonContainer) {
          if (resource == null || resource.available == false) {
            acceleratedCheckoutButtonContainer == null ? void 0 : acceleratedCheckoutButtonContainer.setAttribute("hidden", "true");
          } else {
            acceleratedCheckoutButtonContainer == null ? void 0 : acceleratedCheckoutButtonContainer.removeAttribute("hidden");
          }
        }
        if (resource) {
          const productVariantMedia = (_d = (_c = resource.featured_media) == null ? void 0 : _c.preview_image) == null ? void 0 : _d.src;
          if (productVariantMedia) {
            (_e = this.refs.addToCartButtonContainer) == null ? void 0 : _e.setAttribute(
              "data-product-variant-media",
              productVariantMedia + "&width=100"
            );
          }
        }
        const {
          quantityRules,
          pricePerItem,
          quantitySelector,
          productFormButtons,
          quantityLabel,
          quantitySelectorWrapper
        } = this.refs;
        const newQuantityInput = (
          /** @type {HTMLInputElement | null} */
          html.querySelector('quantity-selector-component input[ref="quantityInput"]')
        );
        if ((quantitySelector == null ? void 0 : quantitySelector.updateConstraints) && newQuantityInput) {
          quantitySelector.updateConstraints(newQuantityInput.min, newQuantityInput.max || null, newQuantityInput.step);
          this.dataset.quantityDefault = newQuantityInput.min || "1";
        }
        const newQuantityRules = html.querySelector(".quantity-rules");
        const isQuantityRulesChanging = !!quantityRules !== !!newQuantityRules;
        const newPricePerItem = html.querySelector("price-per-item");
        const isPricePerItemChanging = !!pricePerItem !== !!newPricePerItem;
        if ((isQuantityRulesChanging || isPricePerItemChanging) && quantitySelector) {
          const currentQuantityValue = (_f = quantitySelector.getValue) == null ? void 0 : _f.call(quantitySelector);
          const newProductFormButtons = html.querySelector(".product-form-buttons");
          if (productFormButtons && newProductFormButtons) {
            morph(productFormButtons, newProductFormButtons);
            const newQuantityInputElement = (
              /** @type {HTMLInputElement | null} */
              html.querySelector('quantity-selector-component input[ref="quantityInput"]')
            );
            if (((_g = this.refs.quantitySelector) == null ? void 0 : _g.updateConstraints) && newQuantityInputElement && currentQuantityValue) {
              this.refs.quantitySelector.setValue(currentQuantityValue);
              this.refs.quantitySelector.updateConstraints(
                newQuantityInputElement.min,
                newQuantityInputElement.max || null,
                newQuantityInputElement.step
              );
              this.dataset.quantityDefault = newQuantityInputElement.min || "1";
            }
          }
        } else {
          const morphTargets = [
            [".quantity-label", quantityLabel, quantitySelector],
            [".quantity-rules", quantityRules, this.refs.productFormButtons],
            ["price-per-item", pricePerItem, quantitySelectorWrapper]
          ];
          for (const [selector, currentElement, fallback] of morphTargets) {
            __privateMethod(this, _ProductFormComponent_instances, morphOrUpdateElement_fn).call(this, currentElement, html.querySelector(selector), fallback);
          }
        }
        const currentVolumePricing = this.refs.volumePricing;
        const newVolumePricing = html.querySelector("volume-pricing");
        __privateMethod(this, _ProductFormComponent_instances, morphOrUpdateElement_fn).call(this, currentVolumePricing, newVolumePricing, this.refs.productFormButtons);
        const hasB2BFeatures = quantityRules || newQuantityRules || pricePerItem || newPricePerItem || currentVolumePricing || newVolumePricing;
        if (__privateGet(this, _cartAddPending) || __privateGet(this, _cartReviewRequired)) this.lockCartAdd();
        if (!hasB2BFeatures) return;
        try {
          await this.refreshProductCart(null, null, generation);
        } catch (error) {
          console.warn("[product-form] Cart refresh failed:", error);
        }
      } catch (error) {
        if (generation !== __privateGet(this, _variantChangeGeneration) || __privateGet(this, _abortController).signal.aborted) return;
        this.refs.variantId.value = "";
        this.refs.variantId.disabled = true;
        for (const container of this.querySelectorAll("add-to-cart-component")) container.disable();
        if (status) {
          status.textContent = this.dataset.variantError || "";
          status.hidden = false;
        }
      } finally {
        if (generation === __privateGet(this, _variantChangeGeneration)) {
          __privateSet(this, _variantChangeInProgress, false);
          __privateSet(this, _addToCartQueue, []);
          if (__privateGet(this, _cartAddPending) || __privateGet(this, _cartReviewRequired)) this.lockCartAdd();
        }
      }
    });
  }
  async refreshProductCart(items = null, ticket = null, variantGeneration) {
    const lifecycle = __privateGet(this, _abortController);
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (lifecycle.signal.aborted) abort();
    else lifecycle.signal.addEventListener("abort", abort, { once: true });
    try {
      return await applyCurrentCartItems(items, ticket, controller, (currentItems) => {
        if (lifecycle.signal.aborted || variantGeneration !== void 0 && variantGeneration !== __privateGet(this, _variantChangeGeneration)) return;
        const cart = { items: currentItems };
        __privateMethod(this, _ProductFormComponent_instances, updateCartQuantity_fn).call(this, cart);
        return cart;
      });
    } finally {
      lifecycle.signal.removeEventListener("abort", abort);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    if (__privateGet(this, _abortController).signal.aborted) __privateSet(this, _abortController, new AbortController());
    const { signal } = __privateGet(this, _abortController);
    const target = this.closest(".shopify-section, dialog, product-card");
    target == null ? void 0 : target.addEventListener(StandardEvents.productSelect, __privateGet(this, _onProductSelect), { signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _onCartUpdate), { signal });
    this.syncAddCheckout();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _abortController).abort();
    this.syncAddCheckout();
    const addController = __privateGet(this, _cartAddController);
    if (addController) addController.abort();
    ++__privateWrapper(this, _variantChangeGeneration)._;
    __privateSet(this, _variantChangeInProgress, false);
    __privateSet(this, _addToCartQueue, []);
    if (__privateGet(this, _timeout)) clearTimeout(__privateGet(this, _timeout));
  }
  syncAddCheckout() {
    const state = __privateGet(this, _abortController).signal.aborted ? null : __privateGet(this, _cartAddPending) ? "pending" : __privateGet(this, _cartReviewRequired) ? "failed" : null;
    setCartCheckout(this, state);
  }
  lockCartAdd() {
    this.syncAddCheckout();
    for (const container of this.querySelectorAll("add-to-cart-component")) container.disable();
    if (this.refs.acceleratedCheckoutButtonContainer) this.refs.acceleratedCheckoutButtonContainer.setAttribute("hidden", "true");
  }
  showCartAddStatus(message, review = false) {
    const { cartAddStatus, cartAddMessage, cartAddReview, cartReviewConfirm } = this.refs;
    if (cartAddStatus && cartAddMessage) {
      cartAddMessage.textContent = message;
      cartAddStatus.hidden = false;
      if (cartAddReview) cartAddReview.hidden = !review;
      if (cartReviewConfirm) cartReviewConfirm.hidden = !review;
    } else {
      __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, message);
    }
  }
  releaseCartAdd() {
    this.syncAddCheckout();
    if (__privateGet(this, _cartReviewRequired) || __privateGet(this, _variantChangeInProgress) || !this.refs.variantId.value || this.refs.variantId.disabled) return;
    for (const container of this.querySelectorAll("add-to-cart-component")) container.enable();
    const accelerated = this.refs.acceleratedCheckoutButtonContainer;
    if (accelerated && !__privateGet(this, _cartAcceleratedWasHidden)) accelerated.removeAttribute("hidden");
  }
  async handleCartReview(event) {
    event.preventDefault();
    if (!__privateGet(this, _cartReviewRequired) || __privateGet(this, _cartAddPending)) return;
    __privateSet(this, _cartAddPending, true);
    this.syncAddCheckout();
    const controller = new AbortController();
    __privateSet(this, _cartAddController, controller);
    this.setAttribute("aria-busy", "true");
    if (this.refs.cartReviewConfirm) this.refs.cartReviewConfirm.disabled = true;
    try {
      await this.refreshProductCart();
      __privateSet(this, _cartReviewRequired, false);
      this.showCartAddStatus(this.dataset.cartChecked || "");
    } catch (error) {
      this.showCartAddStatus(this.dataset.cartUncertain || "", true);
    } finally {
      __privateSet(this, _cartAddController, null);
      __privateSet(this, _cartAddPending, false);
      this.removeAttribute("aria-busy");
      if (this.refs.cartReviewConfirm) this.refs.cartReviewConfirm.disabled = false;
      this.releaseCartAdd();
    }
  }
  /** @param {Event} event */
  handleSubmit(event) {
    var _a, _b;
    event.preventDefault();
    if (__privateGet(this, _variantChangeInProgress) || !this.refs.variantId.value) return;
    return __privateMethod(this, _ProductFormComponent_instances, processAddToCart_fn).call(this, void 0, void 0, event);
  }
}
_cartAcceleratedWasHidden = /* @__PURE__ */ new WeakMap();
_cartAddPending = /* @__PURE__ */ new WeakMap();
_cartReviewRequired = /* @__PURE__ */ new WeakMap();
_cartAddController = /* @__PURE__ */ new WeakMap();
_abortController = /* @__PURE__ */ new WeakMap();
_timeout = /* @__PURE__ */ new WeakMap();
_variantChangeInProgress = /* @__PURE__ */ new WeakMap();
_variantChangeGeneration = /* @__PURE__ */ new WeakMap();
_addToCartQueue = /* @__PURE__ */ new WeakMap();
_ProductFormComponent_instances = /* @__PURE__ */ new WeakSet();
getVariantIdInput_fn = function() {
  var _a;
  return (
    /** @type {HTMLInputElement | null} */
    (_a = this.querySelector('input[name="id"]')) == null ? void 0 : _a.value
  );
};
refreshCart_fn = async function() {
  const cartItemsComponent = document.querySelector("cart-items-component");
  if (cartItemsComponent && typeof cartItemsComponent.fetchCartData === "function") return cartItemsComponent.fetchCartData();
  return fetchCartJson("".concat(Theme.routes.cart_url, ".json"), {
    headers: { Accept: "application/json" },
    credentials: "same-origin"
  }, new AbortController(), 15e3);
};
updateCartQuantity_fn = function(cart) {
  const variantIdInput = __privateMethod(this, _ProductFormComponent_instances, getVariantIdInput_fn).call(this);
  if (!variantIdInput) return;
  if (!cart || !Array.isArray(cart.items)) return;
  const cartQty = cart.items.reduce((total, item) => total + (String(item.variant_id) === String(variantIdInput) ? item.quantity : 0), 0);
  const quantitySelector = (
    /** @type {import('@theme/component-cart-quantity-selector').CartQuantitySelectorComponent | null} */
    this.querySelector("quantity-selector-component")
  );
  if (quantitySelector == null ? void 0 : quantitySelector.setCartQuantity) {
    quantitySelector.setCartQuantity(cartQty);
  }
  __privateMethod(this, _ProductFormComponent_instances, updateQuantityLabel_fn).call(this, cartQty);
};
_onCartUpdate = /* @__PURE__ */ new WeakMap();
getIntendedVariantId_fn = function() {
  var _a;
  return new URL(window.location.href).searchParams.get("variant") || ((_a = this.refs.variantId) == null ? void 0 : _a.value) || void 0;
};
getQuantity_fn = function() {
  var _a, _b;
  return Number((_b = (_a = this.refs.quantitySelector) == null ? void 0 : _a.getValue) == null ? void 0 : _b.call(_a)) || Number(this.dataset.quantityDefault) || 1;
};
processAddToCart_fn = async function(overrideVariantId, overrideQuantity, event) {
  if (__privateGet(this, _cartAddPending) || __privateGet(this, _cartReviewRequired) || __privateGet(this, _variantChangeInProgress)) return;
  const containers = Array.from(this.querySelectorAll("add-to-cart-component"));
  if (this.refs.variantId.disabled || containers.some((container) => container.refs.addToCartButton.disabled)) return;
  const form = this.querySelector("form");
  if (!form || form.reportValidity && !form.reportValidity()) return;
  const selector = this.refs.quantitySelector;
  if (selector && selector.canAddToCart && !selector.canAddToCart().canAdd) {
    this.showCartAddStatus(this.dataset.cartCheckQuantity || "");
    return;
  }
  const formData = new FormData(form);
  if (overrideVariantId) formData.set("id", overrideVariantId);
  if (overrideQuantity !== void 0) formData.set("quantity", String(overrideQuantity));
  const id = String(formData.get("id") || "");
  const rawQuantity = formData.get("quantity");
  const itemCount = rawQuantity === null ? Number(this.dataset.quantityDefault || 1) : Number(rawQuantity);
  if (!id || !Number.isInteger(itemCount) || itemCount < 1) {
    this.showCartAddStatus(this.dataset.cartCheckQuantity || "");
    return;
  }
  formData.set("quantity", String(itemCount));
  const sectionIds = [];
  for (const item of document.querySelectorAll("cart-items-component")) {
    if (item.dataset.sectionId && !sectionIds.includes(item.dataset.sectionId)) sectionIds.push(item.dataset.sectionId);
  }
  formData.delete("sections");
  if (sectionIds.length) formData.set("sections", sectionIds.slice(0, 5).join(","));
  formData.set("sections_url", window.location.pathname);
  if (__privateGet(this, _timeout)) clearTimeout(__privateGet(this, _timeout));
  if (this.refs.addToCartTextError) this.refs.addToCartTextError.classList.add("hidden");
  __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this);
  const accelerated = this.refs.acceleratedCheckoutButtonContainer;
  __privateSet(this, _cartAcceleratedWasHidden, accelerated && accelerated.hasAttribute("hidden"));
  __privateSet(this, _cartAddPending, true);
  __privateSet(this, _cartReviewRequired, true);
  this.lockCartAdd();
  this.setAttribute("aria-busy", "true");
  this.showCartAddStatus(this.dataset.cartAdding || "");
  const productId = this.dataset.productId;
  const deferred = CartLinesUpdateEvent.createPromise();
  const ticket = trackCartRequest(deferred.promise);
  deferred.promise.catch(() => {
  });
  this.dispatchEvent(new CartLinesUpdateEvent({
    action: "add",
    context: "product",
    lines: [{ merchandiseId: id, quantity: itemCount }],
    promise: deferred.promise
  }));
  let added = false;
  const freshCart = async () => {
    const controller = new AbortController();
    __privateSet(this, _cartAddController, controller);
    const cart = await fetchCartJson(Theme.routes.cart_url + ".json", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    }, controller, 15e3);
    if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error("Invalid cart response");
    return cart;
  };
  const resolveCart = async (cart, didError, sections) => {
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {
      items: cart.items,
      source: "product-form-component",
      sourceId: String(this.id),
      quantityManagedBySource: true,
      itemCount,
      productId,
      sections,
      didError
    } });
    await this.refreshProductCart(cart.items, ticket);
  };
  try {
    const controller = new AbortController();
    __privateSet(this, _cartAddController, controller);
    const config = fetchConfig("javascript", { body: formData });
    const response = await fetchCartJson(Theme.routes.cart_add_url, {
      ...config,
      headers: { ...config.headers, Accept: "application/json" },
      credentials: "same-origin"
    }, controller, 3e4);
    const lines = response && Array.isArray(response.items) ? response.items : [response];
    if (!lines.some((line) => line && String(line.variant_id || line.id) === id && Number(line.quantity) > 0)) throw new Error("Invalid add response");
    added = true;
    if (__privateGet(this, _abortController).signal.aborted) throw new Error("Product form disconnected");
    const cart = await freshCart();
    await resolveCart(cart, false, response.sections);
    __privateSet(this, _cartReviewRequired, false);
    this.showCartAddStatus(this.dataset.cartAdded || "");
    __privateSet(this, _timeout, setTimeout(() => {
      if (this.refs.cartAddStatus) this.refs.cartAddStatus.hidden = true;
    }, SUCCESS_MESSAGE_DISPLAY_DURATION));
    for (const container of containers) {
      if (typeof container.confirmAdded === "function") {
        try {
          Promise.resolve(container.confirmAdded()).catch((animationError) => console.warn(animationError));
        } catch (animationError) {
          console.warn(animationError);
        }
      }
    }
  } catch (error) {
    __privateSet(this, _cartReviewRequired, true);
    this.showCartAddStatus(added ? this.dataset.cartDrawerError || "" : this.dataset.cartUncertain || "", true);
    this.dispatchEvent(new CartErrorEvent({
      error: error.message || "Cart request failed",
      code: "SERVICE_UNAVAILABLE"
    }));
    if (!added && (error.status === 400 || error.status === 422) && !__privateGet(this, _abortController).signal.aborted) {
      const description = error.data && error.data.description;
      if (typeof description === "string") this.showCartAddStatus(description + " " + (this.dataset.cartUncertain || ""), true);
      try {
        await resolveCart(await freshCart(), true);
      } catch (refreshError) {
        deferred.reject(refreshError);
      }
    } else {
      deferred.reject(error);
    }
  } finally {
    __privateSet(this, _cartAddController, null);
    __privateSet(this, _cartAddPending, false);
    this.removeAttribute("aria-busy");
    this.releaseCartAdd();
    if (event) cartPerformance.measureFromEvent("add:user-action", event);
  }
};
processBatchAddToCart_fn = function(items) {
  if (items.length === 0) return;
  const { addToCartTextError } = this.refs;
  if (__privateGet(this, _timeout)) clearTimeout(__privateGet(this, _timeout));
  const cartItemsComponents = document.querySelectorAll("cart-items-component");
  const cartItemComponentsSectionIds = [];
  for (const item of cartItemsComponents) {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      cartItemComponentsSectionIds.push(item.dataset.sectionId);
    }
  }
  const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
  const deferredEventPromise = CartLinesUpdateEvent.createPromise();
  const ticket = trackCartRequest(deferredEventPromise.promise);
  this.dispatchEvent(
    new CartLinesUpdateEvent({
      action: "add",
      context: "product",
      lines: items.map((item) => ({
        merchandiseId: item.variantId,
        quantity: item.quantity
      })),
      promise: deferredEventPromise.promise
    })
  );
  const payload = {
    items: items.map((item) => ({
      id: Number(item.variantId),
      quantity: item.quantity
    })),
    sections: cartItemComponentsSectionIds.join(",")
  };
  fetch(Theme.routes.cart_add_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(payload)
  }).then((response) => response.json()).then(async (response) => {
    var _a, _b;
    if (response.status) {
      this.dispatchEvent(
        new CartErrorEvent({
          error: response.message || "Add to cart failed",
          code: "INVALID",
          detail: {
            description: response.description,
            errors: response.errors
          }
        })
      );
      __privateMethod(this, _ProductFormComponent_instances, refreshCart_fn).call(this).then(
        (ajaxCart) => deferredEventPromise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
          detail: {
            didError: true,
            items: ajaxCart.items,
            source: "product-form-component",
            sourceId: this.id.toString(),
            itemCount: totalQuantity,
            productId: this.dataset.productId
          }
        })
      ).catch(deferredEventPromise.reject);
      if (!addToCartTextError) return;
      addToCartTextError.classList.remove("hidden");
      const textNode = addToCartTextError.childNodes[2];
      if (textNode) {
        textNode.textContent = response.message;
      } else {
        addToCartTextError.appendChild(document.createTextNode(response.message));
      }
      __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, response.message);
      __privateSet(this, _timeout, setTimeout(() => {
        addToCartTextError.classList.add("hidden");
        __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this);
      }, ERROR_MESSAGE_DISPLAY_DURATION));
      return;
    }
    if (addToCartTextError) {
      addToCartTextError.classList.add("hidden");
      addToCartTextError.removeAttribute("aria-live");
    }
    const allAddToCartContainers = (
      /** @type {NodeListOf<AddToCartComponent>} */
      this.querySelectorAll("add-to-cart-component")
    );
    const anyAddToCartButton = (_a = allAddToCartContainers[0]) == null ? void 0 : _a.refs.addToCartButton;
    if (anyAddToCartButton) {
      const addedTextElement = anyAddToCartButton.querySelector(".add-to-cart-text--added");
      const addedText = ((_b = addedTextElement == null ? void 0 : addedTextElement.textContent) == null ? void 0 : _b.trim()) || Theme.translations.added;
      __privateMethod(this, _ProductFormComponent_instances, setLiveRegionText_fn).call(this, addedText);
      setTimeout(() => __privateMethod(this, _ProductFormComponent_instances, clearLiveRegionText_fn).call(this), SUCCESS_MESSAGE_DISPLAY_DURATION);
    }
    const cart = await __privateMethod(this, _ProductFormComponent_instances, refreshCart_fn).call(this);
    deferredEventPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: "product-form-component",
        sourceId: this.id.toString(),
        quantityManagedBySource: true,
        itemCount: totalQuantity,
        productId: this.dataset.productId,
        sections: response.sections,
        didError: false
      }
    });
    await this.refreshProductCart(cart.items, ticket);
  }).catch((error) => {
    console.error(error);
    deferredEventPromise.reject(error);
    this.dispatchEvent(
      new CartErrorEvent({
        error: (error == null ? void 0 : error.message) || "Network error during add to cart",
        code: "SERVICE_UNAVAILABLE"
      })
    );
  });
};
updateQuantityLabel_fn = function(cartQty) {
  var _a;
  const quantityLabel = this.refs.quantityLabelCartCount;
  if (quantityLabel) {
    const inCartText = (_a = quantityLabel.textContent) == null ? void 0 : _a.match(/\((\d+)\s+(.+)\)/);
    if (inCartText && inCartText[2]) {
      quantityLabel.textContent = "(".concat(cartQty, " ").concat(inCartText[2], ")");
    }
    quantityLabel.classList.toggle("hidden", cartQty === 0);
  }
};
setLiveRegionText_fn = function(text) {
  const liveRegion = this.refs.liveRegion;
  liveRegion.textContent = text;
};
clearLiveRegionText_fn = function() {
  const liveRegion = this.refs.liveRegion;
  liveRegion.textContent = "";
};
morphOrUpdateElement_fn = function(currentElement, newElement, insertReferenceElement = null) {
  if (currentElement && newElement) {
    morph(currentElement, newElement);
  } else if (currentElement && !newElement) {
    currentElement.remove();
  } else if (!currentElement && newElement && insertReferenceElement) {
    insertReferenceElement.insertAdjacentElement(
      "beforebegin",
      /** @type {Element} */
      newElement.cloneNode(true)
    );
  }
};
_onProductSelect = /* @__PURE__ */ new WeakMap();
if (!customElements.get("product-form-component")) {
  customElements.define("product-form-component", ProductFormComponent);
}
export {
  AddToCartComponent
};
